import { ByteUtil, GuidUtil } from '../../utils/index';
import { RequestMsg } from './../../protobuf/request';
import { Constant } from '../../utils/constant';
import { LoginMsg } from './../../protobuf/login';
import { HeartbeatMsg } from './../../protobuf/heartbeat';
import { EventBus } from '../../domain/eventBus/eventBus';
export default {
    doGuidRquest(clientStater) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            clientStater.send(this.buildGuidRequestBody(_guid));
            let _observer = {
                timeout: 10000
            };
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response.msg });
                }
                else {
                    reject({ code: response.code, msg: response.msg });
                }
            }, _observer);
        });
    },
    doLogin(clientStater, token, fromGuid, role) {
        return new Promise((reslove, reject) => {
            EventBus.clear();
            let _guid = GuidUtil.nextId();
            let loginMsgByte = this.buildLoginBody(_guid, token, fromGuid, role);
            clientStater.send(loginMsgByte);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response.msg });
                }
                else {
                    reject({ code: response.code, msg: response.msg });
                }
            });
        });
    },
    // sendHeader(clientStater, fromGuid) {
    //    return this.sendHeart(clientStater, fromGuid)
    // }
    // intervalSendHeart(clientStater: ClientStater, fromGuid: string) {
    //     this.sendHeart(clientStater, fromGuid).then((res) => {
    //         if (res.code == 200) {
    //             setTimeout(() => {
    //                 this.intervalSendHeart(clientStater, fromGuid);
    //             }, 15000)
    //         }
    //         else if (res.code = 502) {
    //             clientStater.ondisconnect()
    //         }
    //     })
    // },
    // 发送心跳
    sendHeart(clientStater, fromGuid) {
        return new Promise((reslove, _reject) => {
            let _guid = GuidUtil.nextId();
            var _heart = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                heartbeatType: HeartbeatMsg.HeartbeatType.KEEPALIVE,
            };
            //编码
            let utf8 = HeartbeatMsg.encode(_heart).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.HEARBEAT]),
                utf8
            ]);
            clientStater.send(sendByte);
            let _obts = {
                timeout: 12000
            };
            clientStater.onevent(_guid, (res) => {
                reslove(res);
            }, _obts);
            // setTimeout(() => {
            //     //check
            //     clientStater.dispatch(_guid, ({ code: 502 }))
            // }, 14000)
        });
    },
    buildLoginBody(guid, token, fromGuid, role) {
        var loginMsg = {
            version: 1,
            fromGuid: fromGuid,
            role: role,
            token: token,
            guid: guid
        };
        //编码
        let utf8 = LoginMsg.encode(loginMsg).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.LOGIN]),
            utf8
        ]);
        return sendByte;
    },
    buildGuidRequestBody(guid) {
        var _request = {
            version: 1,
            guid: guid,
            requestType: RequestMsg.RequestType.GUID
        };
        //编码
        let utf8 = RequestMsg.encode(_request).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.REQUEST]),
            utf8
        ]);
        return sendByte;
    },
    doPullLastMsg(clientStater, _pullLastMsgByte, _guid) {
        return new Promise((reslove, reject) => {
            clientStater.send(_pullLastMsgByte);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response });
                }
                else {
                    reject({ code: response.code, msg: response });
                }
            });
        });
    },
    msgOperate(clientStater, requestContent, _guid) {
        return new Promise((reslove, reject) => {
            clientStater.send(requestContent);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response });
                }
                else {
                    reject({ code: response.code, msg: response });
                }
            });
        });
    },
    pullResponseOperate(clientStater, requestContent, _guid) {
        return new Promise((reslove, reject) => {
            clientStater.send(requestContent);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response });
                }
                else {
                    reject({ code: response.code, msg: response });
                }
            });
        });
    }
};
//# sourceMappingURL=commonBiz.js.map